import { z } from "zod";

export const plaidSuccessMetadataResponseValidator = z.object({
  institution: z.object({ name: z.string(), institution_id: z.string() }),
  account: z.object({
    id: z.string(),
    name: z.string(),
    mask: z.string(),
    type: z.string(),
    subtype: z.string(),
  }),
});
export type PlaidSuccessMetadataResponse = z.infer<
  typeof plaidSuccessMetadataResponseValidator
>;

export const plaidSuccessResponseValidator = z.object({
  public_token: z.string(),
  metadata: plaidSuccessMetadataResponseValidator,
});
export type PlaidSuccessResponse = z.infer<
  typeof plaidSuccessResponseValidator
>;
